<template>
    <div>
        <div class="form-horizontal" encregion="multipart/form-data" @submit.prevent="store"
             @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                    <th>{{ uLang('app.name') }}</th>
                    <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="websiteBranche in websiteBranches">
                    <td>
                        <input type="text" v-if="websiteBranche.editable" class="form-control"
                               :name="websiteBranche.value" v-model="form['value'][websiteBranche.id]">
                        <span v-if="!websiteBranche.editable">{{ websiteBranche.value }}</span>
                    </td>
                    <td>
                        <a href="#" @click.prevent="removeWebsiteBranche(websiteBranche)"
                           class="btn btn-danger" v-if="websiteBranche.deleteable"
                           :title="uLang('app.delete_website_branche')">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newWebsiteBranche"
                           :placeholder="uLang('app.new_website_branche')"
                           :title="uLang('app.add_new_website_branche')">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addWebsiteBranche"
                                :disabled="form.busy">{{
                                uLang('app.create_entity', {entity: lang('app.website_branche')})
                            }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()"
                       class="btn btn-brand"/>
            </div>
        </div>
    </div>
</template>

<script>
import Form from '~/Form/Form'
import {ErrorAlert, SuccessAlert, DestroyAlert} from '~/Swals'
import {AlphabeticalSort} from '~/mixins'

export default {
    props: {
        settingId: {
            required: true,
        },
    },
    mixins: [
        AlphabeticalSort
    ],
    data() {
        return {
            form: new Form({
                value: {},
            }),
            newWebsiteBranche: '',
            websiteBranches: []
        }
    },
    mounted: function () {
        this.retrieveValues();
    },
    methods: {
        async store() {
            this.form['patch']('/api/admin/settings/' + this.settingId)
                .then(response => {
                    this.setValues(response);
                    new SuccessAlert({text: this.uLang('app.entity_updated', {entity: lang('app.website_branches')})}).show();
                })
                .catch(error => {
                    new ErrorAlert({
                        title: uLang('app.oops_something_went_wrong'),
                        text: uLang('app.all_inputs_need_to_be_filled'),
                    }).show();
                });
        },

        setValues(data) {
            data = this.alphabeticalSort(data)

            this.form.value = {};

            this.websiteBranches = data;

            data.forEach(function (websiteBranche) {
                if (websiteBranche.editable) {
                    this.value[websiteBranche.id] = websiteBranche.value;
                }

            }, this.form);

        },

        async retrieveValues() {
            // TODO: Check if this basic setting logic happens in other components, and maybe move to mixin
            const {data} = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

            this.setValues(data);
        },

        addWebsiteBranche() {
            if (this.newWebsiteBranche === '')
                return;


            this.websiteBranches.push(
                {
                    id: this.newWebsiteBranche,
                    value: this.newWebsiteBranche,
                    deleteable: 1,
                    editable: 1
                }
            );
            this.form.value[this.newWebsiteBranche] = this.newWebsiteBranche;
            this.newWebsiteBranche = '';
        },

        removeWebsiteBranche(websiteBranche) {
            new DestroyAlert({entity: this.lang('app.website_branche')}).show().then(async () => {

                delete this.form.value[websiteBranche.id];

                //remove the websiteBranches from the table
                this.websiteBranches = this.websiteBranches.filter(function (current_website_branche) {
                    return current_website_branche.value != websiteBranche.value;
                });
            })
        }
    }
}
</script>

<style lang="css" scoped>

</style>
